import styled from 'styled-components'
import { Card } from 'react-bootstrap'

export const StepCard = styled(Card)`
  background: #2a2a2a;
  border: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  &.locked {
    .lock-icon-container {
      z-index: 2;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.65);
      border-radius: 8px;
      pointer-events: none;
      z-index: 1;
    }
  }
`

interface HeaderProps {
  $gradient: string
}

export const StepHeader = styled.div<HeaderProps>`
  background: ${(props) => props.$gradient};
  padding: 1rem;
  border-radius: 8px 8px 0 0;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  .lock-icon-container {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
`

export const StepContent = styled.div`
  background: #2a2a2a;
  padding: 1rem;
  border-radius: 0 0 8px 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #1a1a1a;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #4a4a4a;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #5a5a5a;
  }
`

export const StatCard = styled.div`
  background: #1a1a1a;
  border-radius: 6px;
  padding: 1.25rem;
  text-align: center;

  .stat-number {
    color: #4dabf7;
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .text-muted {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 0.9rem;
  }
`

export const ValueBox = styled.div`
  background: #1a1a1a;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;

  .label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
  }

  .value {
    color: #ffffff;
    font-family: monospace;
    font-size: 0.9rem;
    word-break: break-all;
  }
`

export const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 0.5rem;

  canvas {
    width: 100% !important;
    height: 100% !important;
  }
`

export const ChartTitle = styled.h5`
  color: #ffffff;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
`

export const ProgressBar = styled.div<{ $progress: number }>`
  width: 100%;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 0.5rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);

  &::after {
    content: '';
    display: block;
    width: ${(props) => props.$progress}%;
    height: 100%;
    background: linear-gradient(90deg, #4a90e2, #800085);
    transition: width 0.3s ease;
    box-shadow: 0 0 8px rgba(74, 144, 226, 0.5);
  }
`

export const ViewContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`

export const SourceGroup = styled.div`
  background: #1a1a1a;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;

  .source-label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
  }

  .dataset-container {
    color: #ffffff;
  }
`

export const ClassificationButton = styled.button`
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #402563, #114ee0);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #402563, #114ee0);
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.02);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  .icon {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  .title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .description {
    font-size: 1rem;
    opacity: 0.8;
    text-align: center;
    max-width: 80%;
  }
`
